import { endpointWrapper } from './meta.api';

/** Hashtags have no Algolia records, so this is a backend lookup, not a search. */
export const searchHashtags = async ({ query, geo, limit, controller }) =>
    endpointWrapper({
        domain: 'ai/hashtag_search',
        controller,
        data: { query, geo, limit },
    });
